module.exports = __webpack_public_path__ + "img/icon-dashboard.bea5c72c.svg";